<template>
    <div class="elec_nbq_manage">
        <div style="position: fixed; width: 57%;">
            <img src="../../../assets/image/custom/nbq_power_bac.png" style="width: 100%; height: auto;"/>
        <div class="elec_click_rec" @click="goBwgDetail"></div>
        </div>
        <div class="nbq_name">{{ curPoint && curPoint.bwg_name }}</div>
        <div class="elec_battery_bottom ">
            <div class="battery_right_cnt elec_battery_bottom_inner">
                <div class="elec_title">{{ $t('photovoltaicPower.nbq') }}</div>
                <!-- <div class="battery_right_btn">
                    <div v-for="item in nbqList" :key="item.point_id" :class="[pscItem.point_id == item.point_id ? 'change_item change_item_s' : 'change_item change_item_us']" @click="changePSC(item)">
                        {{item.point_name}}
                    </div>
                </div> -->
                <div class="bottom_cnt">
                    <div class="right_inner_title">
                        <img src="../../../assets/image/custom/battery_elec_icon.png" style="width: 2rem;height: 2rem;"/>
                        <div class="right_title_name">
                            <div class="right_title_name_left">{{ curPoint && curPoint.point_name }}</div>
                        </div>
                    </div>
                    <el-scrollbar style="height: calc(100% - 2rem); ">
                        <div class="four_table">
                            <!-- <div class="four_table_inner" v-for="(item, index) in pscList" :key="index">
                                <div class="left">{{item.name}}</div>
                                <div class="right">{{item.data}}&nbsp;{{item.unit}}</div>
                            </div> -->
                            <div class="four_table_inner">
                                <div class="left">{{ $t('photovoltaicPower.position') }}</div>
                                <div class="right">{{ curPoint && curPoint.position }}</div>
                            </div>
                            <div class="four_table_inner">
                                <div class="left">{{ $t('photovoltaicPower.elec_day') }}</div>
                                <div class="right">{{ curPoint && curPoint.dtfdl }} {{ curPoint && curPoint.dtfdl_unit }}</div>
                            </div>
                            <div class="four_table_inner">
                                <div class="left">{{ $t('photovoltaicPower.model') }}</div>
                                <div class="right">{{ curPoint && curPoint.model }}</div>
                            </div>
                            <div class="four_table_inner">
                                <div class="left">{{ $t('photovoltaicPower.run_state') }}</div>
                                <div class="right">{{ curPoint && curPoint.os | code_dce(that)  }}</div>
                            </div>
                            <div class="four_table_inner">
                                <div class="left">{{ $t('photovoltaicPower.jialiugonglv') }}</div>
                                <div class="right">{{ curPoint && curPoint.rated_p }} {{ curPoint && curPoint.rated_p_unit }}</div>
                            </div>
                            <div class="four_table_inner">
                                <div class="left">{{ $t('photovoltaicPower.ri_elec') }}</div>
                                <div class="right">{{ curPoint && curPoint.dtfdl }} {{ curPoint && curPoint.dtfdl_unit }}</div>
                            </div>
                            <div class="four_table_inner">
                                <div class="left">{{ $t('photovoltaicPower.shishi') }}</div>
                                <div class="right">{{ curPoint && curPoint.p }} {{ curPoint && curPoint.p_unit }}</div>
                            </div>
                            <div class="four_table_inner">
                                <div class="left">{{ $t('photovoltaicPower.elec_total') }}</div>
                                <div class="right">{{ curPoint && curPoint.zfdl }} {{ curPoint && curPoint.zfdl_unit }}</div>
                            </div>
                        </div>
                    </el-scrollbar>
                </div>
            </div>
        </div>
        <div class="elec_battery_right">
            <div class="battery_right_cnt">
                <div class="elec_title">{{ $t('photovoltaicPower.shunshifenxi') }}</div>
                <div class="battery_right_btn">
                    <div v-for="item in radioButtons"
                        :key="item.point_class_column_kind_id" 
                        :class="[cur_point_class_column_kind_id == item.point_class_column_kind_id ? 'change_item change_item_s' : 'change_item change_item_us']" 
                        @click="changePSC(item)">
                        {{ item.kind_name }}
                    </div>
                </div>
                <div class="bottom_cnt">
                    <el-form label-width="60px" :model="searchForm" class="leader-style-form">
                        <el-row>
                            <el-col :span="18">
                                <el-form-item :label="$t('photovoltaicPower.time')">
                                    <el-date-picker
                                        v-model="searchForm.from_date"
                                        type="date"
                                        :placeholder="$t('photovoltaicPower.daySelection')"
                                        value-format="yyyy-MM-dd"
                                        format="yyyy-MM-dd"
                                        :picker-options="disableDate"
                                        :clearable="false"
                                        :editable="false"
                                    ></el-date-picker>
                                    <span style="color: #fff;display: inline-block; padding: 0 20px">{{ $t('photovoltaicPower.zhi') }}</span>
                                    <el-date-picker
                                        v-model="searchForm.to_date"
                                        type="date"
                                        :placeholder="$t('photovoltaicPower.daySelection')"
                                        value-format="yyyy-MM-dd"
                                        format="yyyy-MM-dd"
                                        :picker-options="disableDate"
                                        :clearable="false"
                                        :editable="false"
                                    ></el-date-picker>
                                    <el-button
                                        type="primary"
                                        size="medium"
                                        @click="search"
                                        icon="el-icon-search"
                                    ></el-button>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6" style="text-align: right;">
                                <el-button
                                    type="primary"
                                    size="medium"
                                    @click="doOpen1"
                                >放大</el-button>
                                <el-button
                                    type="primary"
                                    size="medium"
                                    @click="changeTable(false)"
                                >{{ $t('photovoltaicPower.data') }}</el-button>
                                <el-button
                                    type="primary"
                                    size="medium"
                                    @click="changeTable(true)"
                                >{{ $t('photovoltaicPower.chart') }}</el-button>
                            </el-col>
                        </el-row>
                    </el-form>
                    <div class="jiaoliu_chart">
                        <div
                            class="echart-container"
                            v-if="this.tableSwitch"
                            v-loading="loading"
                            element-loading-text="loading"
                            element-loading-spinner="el-icon-loading"
                            element-loading-background="rgba(0, 0, 0, 0.8)"
                        >
                            <v-chart :auto-resize="true" :options="lineRight1" ref="lineRight1" />
                        </div>
                        <div class="table-container" v-if="!this.tableSwitch">
                            <el-table
                                :data="tableData"
                                border
                                v-loading="Tloading"
                                height="100%"
                                class="leader-style-table"
                            >
                                <el-table-column
                                    v-for="val in tableHeader"
                                    :key="val.column_val"
                                    :prop="val.column_val"
                                    :label="val.column_key"
                                    align="center"
                                ></el-table-column>
                            </el-table>
                        </div>
                    </div>
                </div>
            </div>
            <div class="battery_right_cnt">
                <div class="elec_title">{{ $t('photovoltaicPower.trend') }}</div>
                <div class="battery_right_btn">
                    <div v-for="item in radioButtons2"
                        :key="item.point_class_column_kind_id" 
                        :class="[cur_point_class_column_kind_id2 == item.point_class_column_kind_id ? 'change_item change_item_s' : 'change_item change_item_us']" 
                        @click="changePSC2(item)">
                        {{ item.kind_name }}
                    </div>
                </div>
                <div class="bottom_cnt">
                    <el-form label-width="60px" :model="searchForm2" class="leader-style-form">
                        <el-row>
                            <el-col :span="18">
                                <el-form-item :label="$t('photovoltaicPower.time')">
                                    <el-date-picker
                                        v-model="searchForm2.from_date"
                                        type="date"
                                        :placeholder="$t('photovoltaicPower.daySelection')"
                                        value-format="yyyy-MM-dd"
                                        format="yyyy-MM-dd"
                                        :picker-options="disableDate"
                                        :clearable="false"
                                        :editable="false"
                                    ></el-date-picker>
                                    <span style="color: #fff;display: inline-block; padding: 0 20px">{{ $t('photovoltaicPower.zhi') }}</span>
                                    <el-date-picker
                                        v-model="searchForm2.to_date"
                                        type="date"
                                        :placeholder="$t('photovoltaicPower.daySelection')"
                                        value-format="yyyy-MM-dd"
                                        format="yyyy-MM-dd"
                                        :picker-options="disableDate"
                                        :clearable="false"
                                        :editable="false"
                                    ></el-date-picker>
                                    <el-button
                                        type="primary"
                                        size="medium"
                                        @click="search2"
                                        icon="el-icon-search"
                                    ></el-button>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6" style="text-align: right;">
                                <el-button
                                    type="primary"
                                    size="medium"
                                    @click="doOpen2"
                                >放大</el-button>
                                <el-button
                                    type="primary"
                                    size="medium"
                                    @click="changeTable2(false)"
                                >{{ $t('photovoltaicPower.data') }}</el-button>
                                <el-button
                                    type="primary"
                                    size="medium"
                                    @click="changeTable2(true)"
                                >{{ $t('photovoltaicPower.chart') }}</el-button>
                            </el-col>
                        </el-row>
                    </el-form>
                    <div class="jiaoliu_chart">
                        <div
                            class="echart-container"
                            v-if="this.tableSwitch2"
                            v-loading="loading"
                            element-loading-text="loading"
                            element-loading-spinner="el-icon-loading"
                            element-loading-background="rgba(0, 0, 0, 0.8)"
                        >
                            <v-chart :auto-resize="true" :options="lineRight2" ref="lineRight2" />
                        </div>
                        <div class="table-container" v-if="!this.tableSwitch2">
                            <el-table
                                :data="tableData2"
                                border
                                v-loading="Tloading"
                                height="100%"
                                class="leader-style-table"
                            >
                                <el-table-column
                                    v-for="val in tableHeader2"
                                    :key="val.column_val"
                                    :prop="val.column_val"
                                    :label="val.column_key"
                                    align="center"
                                ></el-table-column>
                            </el-table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="bottom_rec">
            <div class="bottom_item_div" @mouseenter="hover(1, true)" @mouseleave="hover(1, false)" @click="goRouter(1)">
                <img v-if="selectedBottom == 1" src="../../../assets/image/custom/elec_bottom1_s.png" />
                <img v-else src="../../../assets/image/custom/elec_bottom1_us.png" />
                <div>组件总览</div>
            </div>
            <div class="bottom_item_div" @mouseenter="hover(2, true)" @mouseleave="hover(2, false)" @click="goRouter(2)">
                <img v-if="selectedBottom == 2" src="../../../assets/image/custom/elec_bottom2_s.png" />
                <img v-else src="../../../assets/image/custom/elec_bottom2_us.png" />
                <div>逆变器</div>
            </div>
            <div class="bottom_item_div" @mouseenter="hover(3, true)" @mouseleave="hover(3, false)" @click="goRouter(3)">
                <img v-if="selectedBottom == 3" src="../../../assets/image/custom/elec_bottom3_s.png" />
                <img v-else src="../../../assets/image/custom/elec_bottom3_us.png" />
                <div>并网柜</div>
            </div>
        </div>
        
        <NbqInstantModule :curPoint="curPoint" :dialogStatus.sync="dialogStatus1" :searchForm="searchForm" @closeDiaCb="closeDiaCb1"></NbqInstantModule>
        
        <NbqMonitorModule :curPoint="curPoint" :dialogStatus.sync="dialogStatus2" :searchForm="searchForm2" @closeDiaCb="closeDiaCb2"></NbqMonitorModule>
    </div>
</template>

<script>
import "echarts/lib/chart/bar";
import "echarts/lib/chart/line";

import "echarts/lib/chart/pie";
import "echarts/lib/chart/bar";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/title";
import "echarts/lib/component/legend";
import "echarts/lib/component/toolbox";
import "echarts/lib/component/markPoint";
import "echarts/lib/component/graphic";
import "echarts/lib/component/markPoint";
import "echarts/lib/component/dataZoom";
import NbqInstantModule from "../bwg/nbq_instant_module.vue";
import NbqMonitorModule from "../bwg/nbq_monitor_module.vue";
import * as api from "@/http/api.js";
import { dayTransfer, monthTransfer } from "@/utils/dateTransfer.js";
import unitUtils from "@/utils/unit-exchange.js";
import { getDataAll } from "@/http/http-60.js";
import dayjs from "dayjs";
export default {
    components: {
        NbqInstantModule,
        NbqMonitorModule,
    },
    data() {
        return {
            dialogStatus1: false,
            dialogStatus2: false,
            that: this,
            selectedBottom: '',
            curPoint: null,
            searchForm: {
                from_date: dayjs().format('YYYY-MM-DD'),
                to_date: dayjs().format('YYYY-MM-DD'),
            },
            cur_point_class_column_kind_id: '',
            cur_point_class_column_kind_id2: '',
            pscItem: '',
            pscList: [],
            pcsData: [
                {
                    key: 'pcs_uab',
                    name: this.$t('photovoltaicPower.pcs_uab'),
                    data: '',
                    unit: 'V'
                },
                {
                    key: 'pcs_ubc',
                    name: this.$t('photovoltaicPower.pcs_ubc'),
                    data: '',
                    unit: 'V'
                },
                {
                    key: 'pcs_uca',
                    name: this.$t('photovoltaicPower.pcs_uca'),
                    data: '',
                    unit: 'V'
                },
                {
                    key: 'pcs_ia',
                    name: this.$t('photovoltaicPower.pcs_ia'),
                    data: '',
                    unit: 'A'
                },
                {
                    key: 'pcs_ib',
                    name: this.$t('photovoltaicPower.pcs_ib'),
                    data: '',
                    unit: 'A'
                },
                {
                    key: 'pcs_ic',
                    name: this.$t('photovoltaicPower.pcs_ic'),
                    data: '',
                    unit: 'A'
                },
                {
                    key: 'pcs_lwpl',
                    name: this.$t('photovoltaicPower.pcs_lwpl'),
                    data: '',
                    unit: 'Hz'
                },
                {
                    key: 'pcs_pl',
                    name: this.$t('photovoltaicPower.pcs_pl'),
                    data: '',
                    unit: 'Hz'
                },
                {
                    key: 'pcs_jlldl',
                    name: this.$t('photovoltaicPower.pcs_jlldl'),
                    data: '',
                    unit: ''
                },
                {
                    key: 'pcs_zldy',
                    name: this.$t('photovoltaicPower.pcs_zldy'),
                    data: '',
                    unit: 'V'
                },
                {
                    key: 'pcs_zldl',
                    name: this.$t('photovoltaicPower.pcs_zldl'),
                    data: '',
                    unit: 'A'
                },
                {
                    key: 'pcs_zzlgl',
                    name: this.$t('photovoltaicPower.pcs_zzlgl'),
                    data: '',
                    unit: 'kW'
                },
                {
                    key: 'pcs_scszgl',
                    name: this.$t('photovoltaicPower.pcs_scszgl'),
                    data: '',
                    unit: 'kW'
                },
                {
                    key: 'pcs_p',
                    name: this.$t('photovoltaicPower.pcs_p'),
                    data: '',
                    unit: 'kW'
                },
                {
                    key: 'pcs_q',
                    name: this.$t('photovoltaicPower.pcs_q'),
                    data: '',
                    unit: 'kW'
                },
                {
                    key: 'pcs_yxzt',
                    name: this.$t('photovoltaicPower.pcs_yxzt'),
                    data: '',
                    unit: ''
                },
                {
                    key: 'pcs_zcdl',
                    name: this.$t('photovoltaicPower.pcs_zcdl'),
                    data: '',
                    unit: 'kW.h'
                },
                {
                    key: 'pcs_zfdl',
                    name: this.$t('photovoltaicPower.pcs_zfdl'),
                    data: '',
                    unit: 'kW.h'
                },
                {
                    key: 'pcs_rcdl',
                    name: this.$t('photovoltaicPower.pcs_rcdl'),
                    data: '',
                    unit: 'kW.h'
                },
                {
                    key: 'pcs_rfdl',
                    name: this.$t('photovoltaicPower.pcs_rfdl'),
                    data: '',
                    unit: 'kW.h'
                },
                {
                    key: 'pcs_glys',
                    name: this.$t('photovoltaicPower.pcs_glys'),
                    data: '',
                    unit: ''
                },
                {
                    key: 'pcs_nbwd',
                    name: this.$t('photovoltaicPower.pcs_nbwd'),
                    data: '',
                    unit: '℃'
                },
                {
                    key: 'pcs_srqwd',
                    name: this.$t('photovoltaicPower.pcs_srqwd'),
                    data: '',
                    unit: '℃'
                }
            ],
            batteryData: [
                {
                    key: 'bms_soc',
                    name: this.$t('photovoltaicPower.bms_soc'),
                    data: '',
                    unit: '%'
                },
                {
                    key: 'bms_soh',
                    name: this.$t('photovoltaicPower.bms_soh'),
                    data: '',
                    unit: '%'
                },
                {
                    key: 'bms_dccyxzt',
                    name: this.$t('photovoltaicPower.bms_dccyxzt'),
                    data: '',
                    unit: ''
                },
                {
                    key: 'bms_zt',
                    name: this.$t('photovoltaicPower.bms_zt'),
                    data: '',
                    unit: ''
                },
                {
                    key: 'bms_v',
                    name: this.$t('photovoltaicPower.bms_v'),
                    data: '',
                    unit: 'V'
                },
                {
                    key: 'bms_i',
                    name: this.$t('photovoltaicPower.bms_i'),
                    data: '',
                    unit: 'A'
                },
                {
                    key: 'bms_zgdtdy',
                    name: this.$t('photovoltaicPower.bms_zgdtdy'),
                    data: '',
                    unit: 'V'
                },
                {
                    key: 'bms_zddtdy',
                    name: this.$t('photovoltaicPower.bms_zddtdy'),
                    data: '',
                    unit: 'V'
                },
                {
                    key: 'bms_zgwd',
                    name: this.$t('photovoltaicPower.bms_zgwd'),
                    data: '',
                    unit: '℃'
                },
                {
                    key: 'bms_zdwd',
                    name: this.$t('photovoltaicPower.bms_zdwd'),
                    data: '',
                    unit: '℃'
                },
                {
                    key: 'bms_zgsoc',
                    name: this.$t('photovoltaicPower.bms_zgsoc'),
                    data: '',
                    unit: '%'
                },
                {
                    key: 'bms_zdsoc',
                    name: this.$t('photovoltaicPower.bms_zdsoc'),
                    data: '',
                    unit: '%'
                },
                {
                    key: 'bms_zgdtdybh',
                    name: this.$t('photovoltaicPower.bms_zgdtdybh'),
                    data: '',
                    unit: ''
                },
                {
                    key: 'bms_zddtdybh',
                    name: this.$t('photovoltaicPower.bms_zddtdybh'),
                    data: '',
                    unit: ''
                },
                {
                    key: 'bms_zgwdbh',
                    name: this.$t('photovoltaicPower.bms_zgwdbh'),
                    data: '',
                    unit: ''
                },
                {
                    key: 'bms_zdwdbh',
                    name: this.$t('photovoltaicPower.bms_zdwdbh'),
                    data: '',
                    unit: ''
                },
                {
                    key: 'bms_zdrxcddl',
                    name: this.$t('photovoltaicPower.bms_zdrxcddl'),
                    data: '',
                    unit: 'A'
                },
                {
                    key: 'bms_zdrxfddl',
                    name: this.$t('photovoltaicPower.bms_zdrxfddl'),
                    data: '',
                    unit: 'A'
                },
                {
                    key: 'bms_cndtdygs',
                    name: this.$t('photovoltaicPower.bms_cndtdygs'),
                    data: '',
                    unit: ''
                },
                {
                    key: 'bms_cndtwdgs',
                    name: this.$t('photovoltaicPower.bms_cndtwdgs'),
                    data: '',
                    unit: ''
                },
                {
                    key: 'bms_zddywd',
                    name: this.$t('photovoltaicPower.bms_zddywd'),
                    data: '',
                    unit: '℃'
                },
                {
                    key: 'bms_zxdywd',
                    name: this.$t('photovoltaicPower.bms_zxdywd'),
                    data: '',
                    unit: '℃'
                },
                {
                    key: 'bms_zdwddy',
                    name: this.$t('photovoltaicPower.bms_zdwddy'),
                    data: '',
                    unit: 'V'
                },
                {
                    key: 'bms_zxwddy',
                    name: this.$t('photovoltaicPower.bms_zxwddy'),
                    data: '',
                    unit: 'V'
                },
                {
                    key: 'bms_cddlfz',
                    name: this.$t('photovoltaicPower.bms_cddlfz'),
                    data: '',
                    unit: 'A'
                },
                {
                    key: 'bms_fddlfz',
                    name: this.$t('photovoltaicPower.bms_fddlfz'),
                    data: '',
                    unit: 'A'
                }
            ],
            batteryNameList: [],
            type: 1,
            leftData: [],
            nbqList: [],
            batteryList: [],
            loading: null,
            overLoading: null,
            timer: null,
            point_ids: [],
            x_list: [],
            series: [],
            legend: [],
            tableHeader: [],
            unit: '',
            tableData: [],
            tableSwitch: true,
            x_list2: [],
            series2: [],
            legend2: [],
            tableHeader2: [],
            unit2: '',
            tableData2: [],
            tableSwitch2: true,
            routerL: 2,
            
            searchForm: {
                from_date: dayjs().format('YYYY-MM-DD'),
                to_date: dayjs().format('YYYY-MM-DD')
            },
            searchForm2: {
                from_date: dayjs().format('YYYY-MM-DD'),
                to_date: dayjs().format('YYYY-MM-DD')
            },
            radioButtons: [],
            radioButtons2: [],
        };
    },
    async mounted() {
        const queryData = this.$route.query;
        this.curPoint = {
            point_id: queryData.point_id, 
            point_name: queryData.point_name, 
            position: queryData.position, 
            model: queryData.model,
            bwg_name: queryData.bwg_name,
            point_60_id: queryData.point_60_id,
        };
        this.getData(this.curPoint);
        await this.getPointListByPointClassId();
        await this.getPointColumnKinds(this.curPoint.point_id);
        this.setTimer();
    },
    methods: {
        setTimer() {
            if (this.timer) {
                clearInterval(this.timer);
            }
            this.timer = setInterval(() => {
                if(this.pscItem && this.pscItem.point_id) {
                    this.getPscList();
                    this.getBattery();
                }
            }, 60000);
        },
        hover(item, shown) {
            if(shown) this.selectedBottom = item;
            else this.selectedBottom = '';
        },
        doOpen1() {
            this.dialogStatus1 = true;
        },
        doOpen2() {
            this.dialogStatus2 = true;
        },
        getData(point) {
            let pointIds = [point.point_id];           
            getDataAll(pointIds).then(res => {
                let valueJson = res.bus_json;
                let data = valueJson[point.point_id];
                this.curPoint['p'] = unitUtils.exchangeUnitKWH(data.p).num;
                this.curPoint['p_unit'] = unitUtils.exchangeUnitKWH(data.p).unit;
                this.curPoint['rated_p'] = unitUtils.exchangeUnitKWH(data.rated_p).num;
                this.curPoint['rated_p_unit'] = unitUtils.exchangeUnitKWH(data.rated_p).unit;
                this.curPoint['dtfdl'] = unitUtils.exchangeUnitKWH(data.dangtianfadianliang).num;
                this.curPoint['dtfdl_unit'] = unitUtils.exchangeUnitKWH(data.dangtianfadianliang).unit;
                this.curPoint['zfdl'] = unitUtils.exchangeUnitKWH(data.zongfadianliang).num;
                this.curPoint['zfdl_unit'] = unitUtils.exchangeUnitKWH(data.zongfadianliang).unit;
                this.curPoint['os'] = data && data.operatingstate;
            });
        },
        goBwgDetail() {
            sessionStorage.setItem("activeTab", JSON.stringify({ name:'bwg_power_manage', query:{ point_id: this.curPoint.point_id, point_60_id: this.curPoint.point_60_id, bwg_name: this.curPoint.bwg_name }}));
            this.$router.push({ name:'bwg_power_manage', query:{ point_id: this.curPoint.point_id, point_60_id: this.curPoint.point_60_id, bwg_name: this.curPoint.bwg_name } })
        },
        goRouter(num) {
            if(num == 1) {
                this.$router.push({ name:'roof_manage' })
                sessionStorage.setItem("activeTab", "/roof_manage")
            } else if(num == 2) {
                this.$router.push({ name:'nbq_list' })
                sessionStorage.setItem("activeTab", "/nbq_list")
            }  else if(num == 3) {
                this.$router.push({ name:'bwg_manage' })
                sessionStorage.setItem("activeTab", "/bwg_manage")
            }
        },
        changeTable(showChart) {
            this.tableSwitch = showChart;
        },
        changeTable2(showChart) {
            this.tableSwitch2 = showChart;
        },
        async search() {
            const loading = this.$loading({
                lock: true,
                text: "Loading",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
            await this.getRealTimeData1(this.cur_point_class_column_kind_id);
            loading.close();
        },
        async search2() {
            const loading = this.$loading({
                lock: true,
                text: "Loading",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
            await this.getRealTimeData2(this.cur_point_class_column_kind_id2);
            loading.close();
        },
        async getPointColumnKinds(point_id) {
            await api.getPointColumnKinds({ point_id: point_id }).then(res => {
                if (res && res.error_code === "0") {
                    this.radioButtons = res.bus_json.filter(item => item.point_class_column_kind_id != '1689909850420715530' && item.point_class_column_kind_id != '1689909850420715531');
                    this.radioButtons2 = res.bus_json.filter(item => item.point_class_column_kind_id == '1689909850420715530' || item.point_class_column_kind_id == '1689909850420715531');
                    this.cur_point_class_column_kind_id = this.radioButtons && this.radioButtons.length && this.radioButtons[0].point_class_column_kind_id;
                    this.cur_point_class_column_kind_id2 = this.radioButtons2 && this.radioButtons2.length && this.radioButtons2[0].point_class_column_kind_id;
                    this.getRealTimeData1(this.cur_point_class_column_kind_id);
                    this.getRealTimeData2(this.cur_point_class_column_kind_id2);
                }
            });
        }, 
        async getRealTimeData1(point_class_column_kind_id) {
            if(!point_class_column_kind_id) return;
            this.loading = true;
            await api.getRealTimeData({
                from_date: this.searchForm.from_date,
                to_date: this.searchForm.to_date,
                point_id: this.curPoint.point_id,
                point_class_column_kind_id: point_class_column_kind_id
            }).then(res => {
                if (res && res.error_code === "0") {
                    this.x_list = res.bus_json.x_list;
                    // 数据
                    this.series = [];
                    // 图例
                    this.legend = [];

                    // 表格头部
                    this.tableHeader = [
                        {
                            column_key: this.$t('photovoltaicPower.collectTime'),
                            column_val: "time"
                        }
                    ];
                    res.bus_json.y_list.forEach(item => {
                        let everyData = {
                            name: item.column_desc,
                            type: "line",
                            data: item.dataList,
                            itemStyle: {
                                color: item.column_color
                            },
                            smooth: true,
                            symbol: "none"
                        };
                        this.unit = item.column_unit;
                        this.legend.push(item.column_desc);
                        this.series.push(everyData);
                        // 表格
                        let header_obj = {
                            column_key: item.column_desc,
                            column_val: item.column_name
                        };
                        this.tableHeader.push(header_obj);
                    });

                    //  表格
                    this.tableData = [];
                    this.x_list.forEach((V, index) => {
                        let data_obj = {
                            time: V
                        };
                        res.bus_json.y_list.forEach(T => {
                            data_obj[T.column_name] = T.dataList[index];
                        });
                        this.tableData.push(data_obj);
                    });
                    // setTimeout(() => {
                    // loading.close();
                    this.loading = false;
                    // }, 5000)

                }
            });
        },
        async getRealTimeData2(point_class_column_kind_id) {
            if(!point_class_column_kind_id) return;
            this.loading = true;
            await api.getRealTimeData({
                from_date: this.searchForm2.from_date,
                to_date: this.searchForm2.to_date,
                point_id: this.curPoint.point_id,
                point_class_column_kind_id: point_class_column_kind_id
            }).then(res => {
                if (res && res.error_code === "0") {
                    this.x_list2 = res.bus_json.x_list;
                    // 数据
                    this.series2 = [];
                    // 图例
                    this.legend2 = [];

                    // 表格头部
                    this.tableHeader2 = [
                        {
                            column_key: this.$t('photovoltaicPower.collectTime'),
                            column_val: "time"
                        }
                    ];
                    res.bus_json.y_list.forEach(item => {
                        let everyData = {
                            name: item.column_desc,
                            type: "line",
                            data: item.dataList,
                            itemStyle: {
                                color: item.column_color
                            },
                            smooth: true,
                            symbol: "none"
                        };
                        this.unit2 = item.column_unit;
                        this.legend2.push(item.column_desc);
                        this.series2.push(everyData);
                        // 表格
                        let header_obj = {
                            column_key: item.column_desc,
                            column_val: item.column_name
                        };
                        this.tableHeader2.push(header_obj);
                    });

                    //  表格
                    this.tableData2 = [];
                    this.x_list2.forEach((V, index) => {
                        let data_obj = {
                            time: V
                        };
                        res.bus_json.y_list.forEach(T => {
                            data_obj[T.column_name] = T.dataList[index];
                        });
                        this.tableData2.push(data_obj);
                    });
                    // setTimeout(() => {
                    // loading.close();
                    this.loading = false;
                    // }, 5000)

                }
            });
        },
        async getPointListByPointClassId() {
            this.overLoading = this.$loading({
                lock: true,
                text: 'loading...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            this.chunenglist = [];
            await api.getPointListByPointClassId({point_class_id:'020'}).then(res => {
                if (res && res.error_code == 0) {
                    this.leftData = res.bus_json.filter(item => item.collector_id != null);
                    this.changeChuneng(1);
                }
            });
        },
        async getNbqList(point_id) {
            await api.getNbqList({point_id: point_id}).then(res => {
                if (res && res.error_code == 0) {
                    this.nbqList = res.bus_json.nbqList;
                    this.pscItem = this.nbqList && this.nbqList.length>0 ? this.nbqList[0] : '';
                    if(this.pscItem && this.pscItem.point_id) {
                        this.getPscList();
                        this.getBattery();
                    }
                }
            });
        },
        async getPscList() {
            await getDataAll([this.pscItem.point_id]).then(res => {
                let valueJson = res.bus_json;
                if(valueJson[this.pscItem.point_id]) {
                    const realData = valueJson[this.pscItem.point_id];
                    let temp = this.pcsData;
                    temp.forEach(item => {
                        if(item.key == 'pcs_yxzt') {
                            if(realData[item.key] == 0) item.data = this.$t('roofManage.pcs_yxzt0');
                            else if(realData[item.key] == 1) item.data = this.$t('roofManage.pcs_yxzt1');
                            else if(realData[item.key] == 2) item.data = this.$t('roofManage.pcs_yxzt2');
                            else if(realData[item.key] == 3) item.data = this.$t('roofManage.pcs_yxzt3');
                            else if(realData[item.key] == 4) item.data = this.$t('roofManage.pcs_yxzt4');
                            else if(realData[item.key] == 5) item.data = this.$t('roofManage.pcs_yxzt5');
                            else if(realData[item.key] == 6) item.data = this.$t('roofManage.pcs_yxzt6');
                        } else {
                            item.data = realData[item.key];
                        }
                    })
                    this.pscList = temp;
                }
            });
        },
        async getBattery() {
            await api.getNbqList({point_id: this.pscItem.point_id}).then(res => {
                if (res && res.error_code == 0) {
                    this.batteryNameList = res.bus_json.nbqList;
                    this.point_ids = [];
                    this.batteryNameList.forEach(item => {
                        this.point_ids.push(item.point_id)
                    })
                    this.getBatteryAll(this.point_ids)
                }
            });
        },
        async getBatteryAll(point_ids) {
            await getDataAll(point_ids).then(res => {
                let valueJson = res.bus_json;
                this.point_ids.forEach(point_id => {
                    const realData = valueJson[point_id];
                    let temp = this.batteryData;
                    temp.forEach(item => {
                        if(item.key == 'bms_dccyxzt') {
                            if(realData[item.key] == 0) item.data = this.$t('roofManage.battery_run_state0');
                            else if(realData[item.key] == 1) item.data = this.$t('roofManage.battery_run_state1');
                            else if(realData[item.key] == 2) item.data = this.$t('roofManage.battery_run_state2');
                            else if(realData[item.key] == 3) item.data = this.$t('roofManage.battery_run_state3');
                            else if(realData[item.key] == 4) item.data = this.$t('roofManage.battery_run_state4');
                        } else if(item.key == 'bms_zt') {
                            if(realData[item.key] == 1) item.data = this.$t('roofManage.bms_state1');
                            else if(realData[item.key] == 2) item.data = this.$t('roofManage.bms_state2');
                            else if(realData[item.key] == 3) item.data = this.$t('roofManage.bms_state3');
                            else if(realData[item.key] == 4) item.data = this.$t('roofManage.bms_state4');
                        } else {
                            item.data = realData[item.key];
                        }
                    })
                    this.batteryList.push(temp);
                })
            });
        },
        async changeChuneng(type) {
          //  if(!this.loading) 
                // this.loading = this.$loading({
                //     lock: true,
                //     text: 'loading...',
                //     spinner: 'el-icon-loading',
                //     background: 'rgba(0, 0, 0, 0.7)'
                // });
            this.type = type;
            if(type == 1 && this.leftData && this.leftData.length>=1) {
                const point_id = this.leftData[0].point_id;
                await this.getNbqList(point_id);
            }
            if(type == 2 && this.leftData && this.leftData.length>=2) {
                const point_id = this.leftData[1].point_id;
                await this.getNbqList(point_id);
            }
            if(this.overLoading) this.overLoading.close();
        },
        async changePSC(item) {
            const loading = this.$loading({
                lock: true,
                text: "Loading",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
            this.cur_point_class_column_kind_id = item.point_class_column_kind_id;
            await this.getRealTimeData1(this.cur_point_class_column_kind_id);
            loading.close();
        },
        async changePSC2(item) {
            const loading = this.$loading({
                lock: true,
                text: "Loading",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
            this.cur_point_class_column_kind_id2 = item.point_class_column_kind_id;
            await this.getRealTimeData2(this.cur_point_class_column_kind_id2);
            loading.close();
        }
    },
    filters: {
        code_dce(v, that){
            if(!v) return;
            let mun =parseInt(v);
            if(mun===0){return that.$t('osState.standbyInitializes')}
            else if(mun===1){return that.$t('osState.standbyInsulationImpedanceDetection')}
            else if(mun===2){return that.$t('osState.standbyLightDetection')}
            else if(mun===3){return that.$t('osState.standbyGridDetection')}
            else if(mun===256){return that.$t('osState.starting')}
            else if(mun===512){return that.$t('osState.gridConnectedRunning')}
            else if(mun===513){return that.$t('osState.gridConnectedLimitedPower')}
            else if(mun===514){return that.$t('osState.gridConnectedSelfReducingRatedPower')}
            else if(mun===768){return that.$t('osState.shutdownAbnormal')}
            else if(mun===769){return that.$t('osState.shutdownCommand')}
            else if(mun===770){return that.$t('osState.shutdownOVGR')}
            else if(mun===771){return that.$t('osState.shutdownCommunicationBreak')}
            else if(mun===772){return that.$t('osState.shutdownPowerLimited')}
            else if(mun===773){return that.$t('osState.shutdownMannualBoot')}
            else if(mun===774){return that.$t('osState.shutdownDCSwitchC')}
            else if(mun===775){return that.$t('osState.shutdownQuickShutdown')}
            else if(mun===776){return that.$t('osState.shutdownInputUnderpower')}
            else if(mun===1025){return that.$t('osState.powerGridDispatching')}
            else if(mun===1026){return that.$t('osState.powerGridDispatchingQU')}
            else if(mun===1027){return that.$t('osState.powerGridDispatchingPFU')}
            else if(mun===1028){return that.$t('osState.powerGridDispatchingDryContact')}
            else if(mun===1029){return that.$t('osState.powerGridDispatchingQP')}
            else if(mun===1280){return that.$t('osState.spotReady')}
            else if(mun===1281){return that.$t('osState.spotChecking')}
            else if(mun===1536){return that.$t('osState.duringInspection')}
            else if(mun===1792){return that.$t('osState.AFCIChecking')}
            else if(mun===2048){return that.$t('osState.IVScanning')}
            else if(mun===2304){return that.$t('osState.DCInputChecking')}
            else if(mun===2560){return that.$t('osState.runningChargingOffGrid')}
            else if(mun===40960){return that.$t('osState.standbyNoLight')}
            else {
                return v;
            }
        }
    },
    computed: {
        language() {
            return this.$store.state.language.language;
        },
        lineRight1() {
            const options = {
                // title: {
                //     text: "瞬时量趋势分析"
                // },
                tooltip: {
                    trigger: "axis"
                },
                // legend: {
                //     data: this.legend,
                //     textStyle: {
                //         color: "#fff"
                //     }
                // },
                calculable: true,
                xAxis: {
                    data: this.x_list,
                    axisLabel: {
                        // interval: 0, //横轴信息全部显示
                       // rotate: -40, //-30度角倾斜显示
                        //y轴文字的配置
                        textStyle: {
                            color: "#fff" //颜色
                        }
                    },
                    axisLine: {
                        lineStyle: {
                            color: "#fff" // 颜色
                        }
                    }
                },
                yAxis: [
                    {
                        type: "value",
                        name: `${this.unit}`,
                        axisLabel: {
                            //y轴文字的配置
                            textStyle: {
                                color: '#fff' //颜色
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: '#fff' //颜色
                            }
                        }
                    }
                ],
                dataZoom: [
                    {
                        type: "inside", //图表下方的伸缩条
                        show: true, //是否显示
                        realtime: true, //拖动时，是否实时更新系列的视图
                        start: 0, //伸缩条开始位置（1-100），可以随时更改
                        end: 100 //伸缩条结束位置（1-100），可以随时更改
                    }
                ],
                grid: {
                    left: "6%",
                    right: "6%",
                    bottom: "5%",
                    top: "15%",
                    containLabel: true
                },
                series: this.series,
                color: ["#fee098", "#3abd69", "#fe7f65", "#aeaeae"]
            };
            return options;
        },
        lineRight2() {
            const options = {
                // title: {
                //     text: "瞬时量趋势分析"
                // },
                tooltip: {
                    trigger: "axis"
                },
                // legend: {
                //     data: this.legend2,
                //     textStyle: {
                //         color: "#fff"
                //     }
                // },
                calculable: true,
                xAxis: {
                    data: this.x_list2,
                    axisLabel: {
                        // interval: 0, //横轴信息全部显示
                    //    rotate: -40, //-30度角倾斜显示
                        //y轴文字的配置
                        textStyle: {
                            color: "#fff" //颜色
                        }
                    },
                    axisLine: {
                        lineStyle: {
                            color: "#fff" // 颜色
                        }
                    }
                },
                yAxis: [
                    {
                        type: "value",
                        name: `${this.unit2}`,
                        axisLabel: {
                            //y轴文字的配置
                            textStyle: {
                                color: '#fff' //颜色
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: '#fff' //颜色
                            }
                        }
                    }
                ],
                dataZoom: [
                    {
                        type: "inside", //图表下方的伸缩条
                        show: true, //是否显示
                        realtime: true, //拖动时，是否实时更新系列的视图
                        start: 0, //伸缩条开始位置（1-100），可以随时更改
                        end: 100 //伸缩条结束位置（1-100），可以随时更改
                    }
                ],
                grid: {
                    left: "6%",
                    right: "6%",
                    bottom: "5%",
                    top: "15%",
                    containLabel: true
                },
                series: this.series2,
                color: ["#fee098", "#3abd69", "#fe7f65", "#aeaeae"]
            };
            return options;
        },
    },
    destroyed() {
        clearInterval(this.timer);
    }
};
</script>
<style lang="scss">
.elec_nbq_manage {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding: 0 2rem;
    // background: url("../../../assets/image/custom/nbq_power_bac.png") no-repeat left 100%;
    // background-size: 57% auto;
    position: relative;
    color: #fff;
    .elec_click_rec {
        position: absolute;top: 19%; left: 12%; width: 5rem;height: 5rem;cursor: pointer;
    }
    .nbq_name {
        position: absolute;
        top: 11.5rem;
        left: 7.5%;
        width: 8rem;
        height: 1rem;
        text-align: center;
        font-size: 0.85rem;
      //  border: 1px solid red;
    }
    .bottom_rec {
        position: absolute;
        top: calc(100% - 2.5rem);
        left: 0;
        width: 100%;
        height: 5rem;
      //  border: 1px solid red;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        .bottom_item_div {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            div {
                font-size: 1rem;
                background: linear-gradient(to bottom, #fff 60%, rgba(109, 191, 255, 1) 90%);
                background-clip: text;
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
            }
            img {
                height: 4.5rem;
                width: auto;
                margin: 0 0 0 1.5rem;
            }
        }
    }
    .el-carousel {
        height: 100%;
        .el-carousel__container {
            height: 100%;
        }
        .el-carousel__arrow {
            width: 2rem;
            height: 2rem;
        }
    }
    .leader-style-form {
        // display: flex;
        // justify-content: end;
    }
    .leader-style-form .el-button {
        color: #fff;
        border: 1px solid #1876d3;
        border-radius: 0.3rem;
        margin: 0 0 0 0.3rem !important;
    }
    .elec_battery_bottom {
        position: absolute;
        top: 60%;
        left: 0;
        width: 45%;
        height: 40%;
        box-sizing: border-box;
    }
    .elec_battery_bottom_inner {
        width: 100% !important;
        height: 100% !important;
    }
    .battery_right_cnt {
        width: 100%;
        height: 49%;
        margin-bottom: 1%;
        background: url("../../../assets/image/custom/dianchi_rect.png") no-repeat;
        background-size: 100% 100%;
        position: relative;
        .four_table {
            width: 90%;
            margin-left: 5%;
            height: 90%;
            display: inline-flex; 
            flex-flow: row wrap;
            .four_table_inner {
                //border: 1px solid blue;
                width: 50%;
                // height: 2rem;
                min-height: 2rem;
                text-align: center;
                // line-height: 2rem;
                font-size: 0.9rem;
                border-bottom: 1px dotted rgba(24, 47, 76, 1);
                display: inline-flex;
                align-items: center;
                .left {
                    width: 30%;
                    color: rgba(204, 227, 255, 1);
                    text-align: left;
                    font-size: 0.75rem;
                }
                .right {
                    flex: 1;
                    color: rgba(255, 255, 255, 1);
                    text-align: right;
                    font-size: 0.75rem;
                    margin-right: 15%;
                }
                // &:nth-child(4n + 1) {
                //     background-color: red;
                // }
                &:nth-child(2n + 1) {
                    color: rgba(148, 194, 232, 1);
                }
            }
        }
        .elec_title {
            position: absolute;
            top: 2.6%;
            left: 8%;
            color: rgba(148, 194, 232, 1);
            font-size: 0.8rem;
        }
        .bottom_cnt {
            // border: 1px solid red;
            position: absolute;
            top: 15%;
            left: 2rem;
            width: calc(100% - 4rem);
            height: 80%;
            box-sizing: border-box;
            color: rgba(148, 194, 232, 1);
            font-size: 0.8rem;
            .jiaoliu_chart {
                width: 100%;
                // border: 1px solid red;
                height: calc(100% - 2rem);
                .table-container {
                    width: 100%;
                    height: 100%;
                }
                .echart-container {
                    width: 100%;
                    height: 100%;
                    .echarts {
                        width: 100%;
                        height: 100%;
                    }
                }
            }
            .right_inner_title {
                width: 100%;
                display: inline-flex;
                align-items: center;
            }
            .right_title_name {
                border-bottom: 1px solid rgba(19, 125, 254, 0.3);
                width: calc(100% - 3rem);
                margin-left: 1rem;
                position: relative;
                height: 1.4rem;
                .right_title_name_left {
                    position: absolute;
                    top: 0;
                    left: 0;
                    height: 1.4rem;
                    line-height: 1.4rem;
                    width: 35%;
                    border-bottom: 2px solid rgba(19, 125, 254, 1);
                }
            }
        }
        .battery_right_btn {
            position: absolute;
            top: 2%;
            right: 0;
            width: 75%;
            height: 1.5rem;
            // margin-left: 20%;
            //height: 3rem;
            // border: 1px solid red;
            display: inline-flex;
            flex-flow: row wrap;
            align-items: center;
            justify-content: flex-end;
            overflow-x: auto;
            .change_item {
                width: auto;//3.5rem;
                height: 1.2rem;
                line-height: 1.2rem;
                font-size: 0.65rem;
                text-align: center;
                cursor: pointer;
                margin-right: 0.3rem;
                padding: 0 0.2rem;
                margin-bottom: 0.2rem;
            }
            .change_item_s {
                color: #fff;
                border: 1px solid #1876d3;
                // background-color: rgba(148, 194, 232, 1);
                // border-radius: 5px;
            }
            .change_item_us {
                color: #a3a2a2;
                border: 1px solid #1876d3;
            }
        }
    }
    .elec_battery_right {
       // border: 1px solid red;
       position: absolute;
       top: 0;
       left: 45%;
        width: 54%;
        height: calc(100% - 2.5rem);
     //   margin-left: 44%;
      //  margin-top: -5rem;
        box-sizing: border-box;
    }
    .chunenggui {
        cursor: pointer;
        display: inline-flex;
        flex-flow: column;
        img {
            width: 12rem;
        }
        .chunenggui_name {
            height: 3rem;
            line-height: 3rem;
            text-align: center;
            font-size: 0.9rem;
            color: #fff;
        }
        .chunenggui_name_s {
            background: url("../../../assets/image/custom/chunenggui_name_s.png") no-repeat;
        }
        .chunenggui_name_us {
            background: url("../../../assets/image/custom/chunenggui_name_us.png") no-repeat;
        }
    }
    .chunenggui1 {
        position: absolute;
        top: 68%;
        left: 3.5%;
    }
    .chunenggui2 {
        position: absolute;
        top: 68%;
        left: 30.2%;
    }
    .elec_battery_right {

    }
    .el-carousel__arrow {
        background-color: rgba(148, 194, 232, 1);
    }
    .el-carousel__arrow--left {
        left: 0;
    }
    .el-carousel__arrow--right {
        right: 0;
    }
    .red {
        color: red;
    }
    .green {
        color: green;
    }
    .yellow {
        color: yellow;
    }
}
</style>
